import { PATH_NEW_360 } from "@/constants/URL";
import routerWithSidebar from "./routerWithSidebar";
export default {
  path: PATH_NEW_360,
  component: () =>
    import(/* webpackChunkName: "SidebarLayout" */ "@/layout/SidebarLayout/index.vue"),
  children: [
    {
      path: PATH_NEW_360,
      name: "new360",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/new360/index.vue")
      )
    }
  ]
};
